import { UseQueryResult } from '@tanstack/react-query';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';
import { useSession } from '../SessionProvider';
import {
  getOverlayMetadata,
  getOverlayMP,
  GetOverlayProps,
} from './getOverlay';
import { useState } from 'react';
import { Base64String } from '../utils';
import { useTimeZoneContext } from '@ais-ui/utils';

export const useGetOverlayMP = (
  props: GetOverlayProps | null
): UseQueryResult<
  {
    overlay: Base64String;
    overlayCreatedDatetime: string;
    targetCountInfo: string;
    timeUntilNextUpdate: number;
  },
  unknown
> => {
  const { olSession } = useSession();
  const { timeZone } = useTimeZoneContext();
  const [updateInterval, setUpdateInterval] = useState(5000);

  return useQuery({
    queryKey: [
      'getOverlay',
      props?.centerLon,
      props?.centerLat,
      props?.zoomLevel,
      props?.height,
      props?.width,
      timeZone,
    ],
    queryFn: async () => {
      const result = await getOverlayMP(olSession, props!, timeZone);
      const metadata = await getOverlayMetadata(olSession);
      setUpdateInterval(metadata.timeUntilNextUpdate);

      // Merge overlay result with metadata to include all keys
      return {
        ...result,
        ...metadata,
      };
    },
    enabled: props !== null,
    refetchInterval: updateInterval,
    gcTime: 10,
    retry: 3,
    retryDelay: 1000,
  }, 'overlay:get');
};
